import { Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';

export const Title = () => {
  const MedicationsAndPrescriptionsDictionary =
    Dictionary[DICTIONARY.MedicationsAndPrescriptionsLobby];

  const isDesktop = useIsDesktop();
  return (
    <>
      <Typography
        tabIndex={0}
        variant={isDesktop ? 'h2' : 'h2'}
        mt={isDesktop ? 3 : 2}
        component={'h1'}
      >
        {MedicationsAndPrescriptionsDictionary.title}
      </Typography>
    </>
  );
};
